import { Flex } from '@chakra-ui/react';
import { useCallback, useContext, useEffect, useRef } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { getMultisigAccountData } from '../../api/multisigAPI';
import { GlobalContext } from '../../providers/Global';
import { ApplicationRoutes } from '../../utils/routes';
import Menu from './components/Menu';
import { SCREEN_LG, SCREEN_MD } from 'utils/constants';
import { useMediaQuery } from 'react-responsive';

const Dashboard = () => {
  const { walletId } = useParams();
  const navigate = useNavigate();

  const {
    connection: { accountId },
    updateAccount,
    refreshKey,
  } = useContext(GlobalContext);

  const isScreenMedium = useMediaQuery({ query: `(max-width: ${SCREEN_MD})` });
  const isScreenLarge = useMediaQuery({ query: `(max-width: ${SCREEN_LG})` });

  const prevWalletId = useRef<string | null>(null);

  const fetchAccountData = useCallback(async () => {
    if (walletId) {
      if (prevWalletId.current !== walletId) {
        updateAccount({});
        prevWalletId.current = walletId;
      }
      const data = await getMultisigAccountData(walletId);
      if (data?.data) {
        updateAccount(data.data);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletId]);

  useEffect(() => {
    if (!accountId) {
      navigate(ApplicationRoutes.Base);
    }
    fetchAccountData();
  }, [accountId, fetchAccountData, navigate, refreshKey]);

  return (
    <Flex
      pt={isScreenMedium ? 0 : 6}
      pb={isScreenMedium ? 0 : 8}
      w="full"
      direction={isScreenLarge ? 'column' : 'row'}
    >
      {
        !isScreenLarge && (
          <Menu />
        )
      }
      <Outlet />
    </Flex>
  );
};

export default Dashboard;
